import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { handleApiError } from "../../helpers";
import { getLoanTransactionApi } from "../../apis/loan";
import { LoanOfferTabs, LoanTransaction } from "../../interfaces";

export const useFetchLoanTransactions = () => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const [fetchingTransactions, setFetchingTransactions] = useState(false);
  const [transactions, setTransactions] = useState<null | LoanTransaction[]>(null);

  const handleFetchLoanTransactions = async () => {
    setFetchingTransactions(true);
    try {
      const response = await getLoanTransactionApi(+id);
      const loanTransactions: LoanTransaction[] = response.data;
      setTransactions(loanTransactions);
      setFetchingTransactions(false);
    } catch (error) {
      toast.error(handleApiError(error));
      setFetchingTransactions(false);
    }
  };

  useEffect(() => {
    if (tab === LoanOfferTabs.TRANSACTIONS) {
      handleFetchLoanTransactions();
    }
  }, [tab, id]);

  return {
    transactions,
    fetchingTransactions,
    handleFetchLoanTransactions,
  };
};
